import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUserProfile } from '../../redux/network/userApi';
import ReactGA from 'react-ga4';
import CoachSidebar from './CoachSidebar';
import './landing.scss';


import { Menu, X } from 'lucide-react';

export default function LandingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const jwtToken = localStorage.getItem("BQS_TOKEN");
  const userData = useSelector((state) => state.user.profile);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  //to get remainingReviews
  useEffect(() => {
    if (jwtToken) {
      console.log("calling dispatcher");
      dispatch(getUserProfile(jwtToken))
    }
  }, [jwtToken, dispatch])

  // GA: pageview for Coach Flow routes under landing
  useEffect(() => {
    try {
      ReactGA.send({ hitType: 'pageview', page: pathname, title: 'Coach Flow' });
    } catch { }
  }, [pathname]);




  return (
    <div className='flex flex-row min-h-screen bg-gray-50 relative'>
      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm animate-in fade-in duration-200"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar Wrapper */}
      <div className={`
        fixed top-0 left-0 bottom-0 z-50 transition-transform duration-300 ease-in-out h-full
        lg:relative lg:translate-x-0 lg:z-auto lg:h-auto
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <CoachSidebar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 w-full mx-auto overflow-y-auto duration-300 ease-in-out py-4 px-8 lg:py-6 lg:px-12 max-w-full">
        {/* Mobile Hamburger Button */}
        <button
          className="lg:hidden fixed top-24 right-4 z-30 p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 text-gray-700 transition-colors border border-gray-100"
          onClick={() => setIsMobileMenuOpen(true)}
        >
          <Menu size={24} />
        </button>

        <Outlet />
      </div>
    </div>
  );
}
